<template>
    <!-- Page Header-->
    <Header :title="title" :subtitle="subtitle" />
    <!-- Main Content-->
    <main>
        <div class="container px-4 px-lg-5">
            <div class="row gx-4 gx-lg-5 justify-content-center">
                <el-card style="max-width: 500px;margin-bottom: 2rem;">
                    <div class="form-wrap">
                        <ul class="menu-tab">
                            <el-segmented v-model="data.current_menu" :options="data.tab_menu" />
                        </ul>
                        <el-form :model="data.form" :rules="data.form_rules" label-width="auto">
                            <el-form-item prop="username" label="用户名">
                                <el-input v-model="data.form.username" autocomplete="off"></el-input>
                            </el-form-item>
                            <el-form-item prop="password" label="密码">
                                <el-input type="password" v-model="data.form.password" autocomplete="off"></el-input>
                            </el-form-item>
                            <el-form-item prop="passwords" v-if="data.current_menu === 'register'" label="确认密码">
                                <el-input type="password" v-model="data.form.passwords" autocomplete="off"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="danger" @click="submitForm" :disabled="data.submit_button_disabled"
                                    :loading="data.submit_button_loading">
                                    {{ data.current_menu === "login" ? "登录" : "注册" }}
                                </el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </el-card>
            </div>
        </div>
    </main>
</template>
<script setup>
import Header from '../components/Header.vue'
import { reactive, ref, onBeforeUnmount, getCurrentInstance } from "vue";
import { mapActions, useStore } from "vuex";
import { useRouter } from "vue-router";
import service from '../utils/request'

import {
    validate_email,
    validate_password,
    validate_code,
    validate_username
} from "../utils/validate";
import { GetCode } from "../utils/common";
import { Register } from "../utils/account";
import userApi from '../api/user'
import { ElMessage } from 'element-plus'
import router from 'router'

const title = "登录"
const subtitle = "欢迎光临"

const { proxy } = getCurrentInstance();
const store = useStore();


// 用户名校验
const validate_name_rules = (rule, value, callback) => {
    let regEmail = validate_username(value);
    if (value === "") {
        callback(new Error("请输入邮箱"));
    } else if (!regEmail) {
        callback(new Error("邮箱格式不正确"));
    } else {
        callback();
    }
};

const validate_password_rules = (rule, value, callback) => {
    let regPassword = validate_password(value);
    // 获取“确认密码”
    //   const passwordsValue = data.form.passwords;
    if (value === "") {
        callback(new Error("请输入密码"));
    } else if (!regPassword) {
        callback(new Error("请输入>=6并且<=20位的密码，包含数字、字母"));
    } else {
        callback();
    }
};

// 校验确认密码
const validate_passwords_rules = (rule, value, callback) => {
    // 如果是登录，不需要校验确认密码，默认通过
    if (data.current_menu === "login") {
        callback();
    }
    let regPassword = validate_password(value);
    // 获取“密码”
    const passwordValue = data.form.password;
    if (value === "") {
        callback(new Error("请输入密码"));
    } else if (!regPassword) {
        callback(new Error("请输入>=6并且<=20位的密码，包含数字、字母"));
    } else if (passwordValue && passwordValue !== value) {
        callback(new Error("两次密码不一致"));
    } else {
        callback();
    }
};
const validate_code_rules = (rule, value, callback) => {
    let regCode = validate_code(value);
    if (value === "") {
        callback(new Error("请输入验证码"));
    } else if (!regCode) {
        callback(new Error("请输入6位的验证码"));
    } else {
        callback();
    }
};

const data = reactive({
    form: {
        username: "", // 用户名
        password: "", // 密码
        passwords: "", // 确认密码
        // code: "", // 验证码
    },
    form_rules: {
        username: [{ validator: validate_name_rules, trigger: "change" }],
        password: [{ validator: validate_password_rules, trigger: "change" }],
        passwords: [{ validator: validate_passwords_rules, trigger: "change" }],
        // code: [{ validator: validate_code_rules, trigger: "change" }],
    },
    tab_menu: [
        { value: "login", label: "登录" },
        { value: "register", label: "注册" },
    ],
    current_menu: "login",
    /**
     * 获取验证码按钮交互
     */
    code_button_disabled: false,
    code_button_loading: false,
    code_button_text: "获取验证码",
    code_button_timer: null,
    // 提交按钮
    submit_button_disabled: false,
    loading: false,
});


// 获取验证码
const handlerGetCode = () => {
    const username = data.form.username;
    const password = data.form.password;
    const passwords = data.form.passwords;
    // 校验用户名
    if (!validate_email(username)) {
        proxy.$message.error({
            message: "用户名不能为空 或 格式不正确",
            type: "error",
        });
        return false;
    }
    // 校验密码
    if (!validate_password(password)) {
        proxy.$message({
            message: "密码不能为空 或 格式不正确",
            type: "error",
        });
        return false;
    }
    // 判断非 登录 时，校验两次密码
    if (data.current_menu === "register" && password !== passwords) {
        proxy.$message({
            message: "两次密码不一致",
            type: "error",
        });
        return false;
    }

    // // 获取验证码接口
    // const requestData = {
    //   username: data.form.username,
    //   module: data.current_menu,
    // };
    // data.code_button_loading = true;
    // data.code_button_text = "发送中";
    // GetCode(requestData)
    //   .then((response) => {
    //     const resData = response;
    //     // 激活提交按钮
    //     data.submit_button_disabled = false;
    //     // 用户名存在
    //     if (resData.resCode === 1024) {
    //       proxy.$message.error(resData.message);
    //       return false;
    //     }
    //     // 成功 Elementui 提示
    //     proxy.$message({
    //       message: resData.message,
    //       type: "success",
    //     });
    //     // 执行倒计时
    //     countdown();
    //   })
    //   .catch(() => {
    //     data.code_button_loading = false;
    //     data.code_button_text = "获取验证码";
    //   });
};

// /** 倒计时 */
// const countdown = (time) => {
//   if (time && typeof time !== "number") {
//     return false;
//   }
//   let second = time || 60; // 默认时间
//   data.code_button_loading = false; // 取消加载
//   data.code_button_disabled = true; // 禁用按钮
//   data.code_button_text = `倒计进${second}秒`; // 按钮文本
//   // 判断是否存在定时器，存在则先清除
//   if (data.code_button_timer) {
//     clearInterval(data.code_button_timer);
//   }
//   // 开启定时器
//   data.code_button_timer = setInterval(() => {
//     second--;
//     data.code_button_text = `倒计进${second}秒`; // 按钮文本
//     if (second <= 0) {
//       data.code_button_text = `重新获取`; // 按钮文本
//       data.code_button_disabled = false; // 启用按钮
//       clearInterval(data.code_button_timer); // 清除倒计时
//     }
//   }, 1000);
// };

// formName
const submitForm = () => {
    data.current_menu === "login" ? login() : register();
    // data.form.validate((valid) => {
    // if (valid) {
    //     data.current_menu === "login" ? login() : register();
    // } else {
    //     data.current_menu === "login" ? login() : register();
    //     // alert("表单验证不通过");
    //     // return false;
    //     return;
    // }
    // });
};

/** 注册 */
const register = () => {
    const requestData = {
        username: data.form.username,
        password: data.form.password,
    };
    data.submit_button_loading = true;
    if (data.form.password == data.form.passwords) {
        axios.post("/admin/employee", requestData).then(res => {
            if (res.data != false) {
                localStorage.setItem('token', res.data.data.token);
                router.push('/homepage');
            } else {
                data.submit_button_loading = false;
                ElMessage.error("注册失败，请重试");
            }
        }
        )
    } else {
        data.submit_button_loading = false;
        ElMessage.error("密码不一致，请重试");
    }


    Register(requestData)
        .then((response) => {
            proxy.$message({
                message: response.message,
                type: "success",
            });
            reset();
        })
        .catch(() => {
            data.submit_button_loading = false;
        });
};

/** 登录 */
const login = () => {
    const requestData = {
        username: data.form.username,
        password: data.form.password,
    };
    data.submit_button_loading = true;

    service.post("/admin/employee/login", requestData).then(res => {
        if (res.data != false) {
            localStorage.setItem('token', res.data.token);
            router.push('/homepage/employee');
        } else {
            data.submit_button_loading = false;
            ElMessage.error("用户名或密码错误，请重试");
        }
    }
    )
}

/** 重置 */
const reset = () => {
    // 重置表单
    // proxy.$refs.form.resetFields();
    // 切回登录模式
    data.current_menu = "login";
    // 清除定时器
    data.code_button_timer && clearInterval(data.code_button_timer);
    // 获取验证码重置文本
    data.code_button_text = "获取验证码";
    // 获取验证码激活
    data.code_button_disabled = false;
    // 禁用提交按钮
    data.submit_button_disabled = true;
    // 取消提交按钮加载
    data.submit_button_loading = false;
};
// 组件销毁之前 - 生命周期
onBeforeUnmount(() => {
    clearInterval(data.code_button_timer); // 清除倒计时
});
</script>
<style lang="scss" scoped>
.menu-tab {
    text-align: center;

    li {
        display: inline-block;
        padding: 10px 24px;
        margin: 0 10px;
        color: black;
        font-size: 2rem;
        border-radius: 5px;
        cursor: pointer;

        &.current {
            background-color: skyblue;
            color: white;
        }
    }
}

.form-label {
    display: block; // 转为块元素
    color: black; // 设置字体颜色
    font-size: 1.5rem; // 设置字体大小
}

.el-inner {
    font-size: 1.5rem;
    margin: 1.5rem;
    height: 2rem;
}

.el-button-block {
    font-size: 1.5rem;
    padding: 1.5rem;
    margin-top: 2rem;
}
</style>